// extracted by mini-css-extract-plugin
export default {"row":"AccessTokenStatistics_row__OXARX","title":"AccessTokenStatistics_title__W1KF9"};